// extracted by mini-css-extract-plugin
export default {"control":"control-group_control__mtPm6","options":"control-group_options__uGqew","optionsVertical":"control-group_optionsVertical__gOlWS"};